import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import { SingleSignOn, LineLogin } from './login';

Vue.use(VueRouter);

// 解決 ElementUI 導航欄，在 vue-router 3.0 版本以上重複點菜單報錯問題
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId',
    name: 'FrontPage',
    component: () => import('@/views/ActivityFrontPage.vue'),
  },
  { // 2021.05.10 調整流程，故SSO登入時不會有activityResultId
    path: '/:eventId/:companyId/:memberSourceId/:activityId/SSO',
    name: 'SsoCallBack',
    beforeEnter: (to, from, next) => {
      if (!to.query.code) next({ name: 'Error' });

      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', { name: 'memberSourceId', value: to.params.memberSourceId });
      store.commit('set', { name: 'activityId', value: to.params.activityId });

      SingleSignOn(to, next);
    },
  },
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId/:activityResultId/SSO',
    name: 'SsoCallBackOld',
    beforeEnter: (to, from, next) => {
      if (!to.query.code) next({ name: 'Error' });

      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', { name: 'memberSourceId', value: to.params.memberSourceId });
      store.commit('set', { name: 'activityId', value: to.params.activityId });
      store.commit('set', { name: 'activityResultId', value: to.params.activityResultId });

      SingleSignOn(to, next);
    },
  },
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId/:activityResultId/LineLogin',
    name: 'LineLoginCallBack',
    beforeEnter: (to, from, next) => {
      if (!to.query.code) next({ name: 'Error' });

      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', { name: 'memberSourceId', value: to.params.memberSourceId });
      store.commit('set', { name: 'activityId', value: to.params.activityId });
      store.commit('set', { name: 'activityResultId', value: to.params.activityResultId });

      LineLogin(to.query.code, next);
    },
  },
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId/:activityResultId/callback',
    name: 'CallBack',
    component: () => import('@/views/CallBack.vue'),
  },
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId/:activityResultId/event',
    name: 'EventPage',
    component: () => import('@/views/ActivityEventPage.vue'),
  },
  {
    path: '/:eventId/:companyId/:memberSourceId/:activityId/end',
    name: 'EndPage',
    component: () => import('@/views/ActivityEndPage.vue'),
  },
  {
    path: '/Error',
    name: 'Error',
    props: true,
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '/LINELoginJumpPage',
    name: 'LINELoginJumpPage',
    beforeEnter(to, from, next) {
      if (to.query.page === 'MgmInvitedSSO') {
        next({
          name: 'MgmInvitedSSO',
          params: {
            companyId: to.query.companyId,
            memberSourceId: to.query.memberSourceId,
            memberId: to.query.memberId,
            activityId: to.query.activityId,
          },
          query: {
            code: to.query.code,
            state: to.query.state,
            friendship_status_changed: to.query.friendship_status_changed,
          },
        });
      }
      next();
    },
  },
  {
    path: '*',
    name: 'NotFound',
    redirect: { name: 'Error' },
  },
  {
    path: '/:companyId/:memberSourceId/:memberId/:activityId/mgminvited',
    name: 'MgmInvitedSSO',
    component: () => import('@/views/MgmInvitedSSO.vue'),
  },
  {
    path: '/FrontPage',
    name: 'FrontPageFake',
    component: () => import('@/views/ActivityFrontPage.vue'),
  },
  {
    path: '/EndPage',
    name: 'EndPageFake',
    component: () => import('@/views/ActivityEndPage.vue'),
  },
  {
    path: '/EventPage',
    name: 'EventPageFake',
    component: () => import('@/views/ActivityEventPage.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH,
  routes,
});

export default router;
